var _circle, _circle2, _circle3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgSpinnersBlocksWave(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3,
    fill: "#ffc001"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsBounce0",
    attributeName: "cy",
    begin: "0;svgSpinners3DotsBounce1.end+0.25s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "#ff4d00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    begin: "svgSpinners3DotsBounce0.begin+0.1s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3,
    fill: "#ffd966"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsBounce1",
    attributeName: "cy",
    begin: "svgSpinners3DotsBounce0.begin+0.2s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgSpinnersBlocksWave);
export default __webpack_public_path__ + "static/media/SvgSpinnersBlocksWave.e8fe0838a81042bd5bdab634d6315377.svg";
export { ForwardRef as ReactComponent };